/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_McpInputs */

const en_directory_agent_readiness_check_mcp = /** @type {(inputs: Directory_Agent_Readiness_Check_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP interface`)
};

const zh_directory_agent_readiness_check_mcp = /** @type {(inputs: Directory_Agent_Readiness_Check_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP 接口`)
};

/**
* | output |
* | --- |
* | "MCP interface" |
*
* @param {Directory_Agent_Readiness_Check_McpInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_mcp = /** @type {((inputs?: Directory_Agent_Readiness_Check_McpInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_McpInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_mcp(inputs)
	return zh_directory_agent_readiness_check_mcp(inputs)
});
export { directory_agent_readiness_check_mcp as "directory.agent_readiness.check.mcp" }